import React from 'react';
import { Link } from 'react-router-dom';
import ahiLogoBlack from '../../../assets/images/ahiLogoBlack.png';

export const Navbar = () => {
  return (
    <nav className="fixed w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100  pb-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img src={ahiLogoBlack} alt="logo" className="h-14 pt-1" />
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link to="/" className="text-gray-900 hover:text-blue-500 px-3 py-2 font-medium transition-colors">
                Home
              </Link>
              <a href="#features" className="text-gray-700 hover:text-blue-500 px-3 py-2 font-medium transition-colors">
                Features
              </a>
              <a href="#pricing" className="text-gray-700 hover:text-blue-500 px-3 py-2 font-medium transition-colors">
                Pricing
              </a>
              <Link
                to="/login"
                className="text-gray-700 hover:text-gray-900 px-4 py-2 font-medium transition-colors"
              >
                Log in
              </Link>
              <Link
                to="/signup"
                className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition-colors font-medium"
              >
                Sign up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};
